"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pdfIcon = _interopRequireDefault(require("../assets/pdfIcon.png"));

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MediaOption = function MediaOption(_ref) {
  var option = _ref.option,
      _onClick = _ref.onClick;
  return option && !(Object.keys(option).length === 0 && option.constructor === Object) && (option.type === _constants.FILE_TYPE_IMAGE ? /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: "media-option-container",
    onClick: function onClick() {
      return _onClick(option);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "media-img",
    loading: "lazy",
    src: option.url,
    className: "media-image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-desc-container"
  }, /*#__PURE__*/_react.default.createElement("p", null, option.fileName))) : /*#__PURE__*/_react.default.createElement("div", {
    role: "presentation",
    className: "media-option-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: option.url
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "media-image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "pdf-img",
    loading: "lazy",
    src: _pdfIcon.default,
    className: "media-image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "media-desc-container"
  }, /*#__PURE__*/_react.default.createElement("p", null, option.fileName)))));
};

MediaOption.propTypes = {
  option: _propTypes.default.shape({
    fileName: _propTypes.default.string.isRequired,
    type: _propTypes.default.string,
    desc: _propTypes.default.string,
    url: _propTypes.default.string.isRequired
  }),
  onClick: _propTypes.default.func
};
MediaOption.defaultProps = {
  option: {},
  onClick: function onClick() {}
};
var _default = MediaOption;
exports.default = _default;